/**
 *  @class
 *  @function CollectionTabs
 */

if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {

    constructor() {
      super();


    }
    connectedCallback() {
      setTimeout(() => {
        this.buttons = Array.from(this.querySelectorAll('button'));
        this.links = this.closest('.section-header').querySelectorAll('.linked-to-tab');
        this.target = this.dataset.target;

        this.buttons.forEach((button, i) => {
          button.addEventListener('click', (event) => {
            let handle = button.dataset.collection;
            [].forEach.call(this.buttons, function(el) {
              el.classList.remove('active');
            });

            if (this.links.length) {
              [].forEach.call(this.links, function(el) {
                el.classList.remove('active');
              });
              this.links[i].classList.add('active');
            }
            button.classList.add('active');
            // Adding a specific class when a pcc-lites tab is clicked
            const flickityViewport = document.querySelector('.collection-tabs .flickity-viewport');
            if (flickityViewport) {
              flickityViewport.classList.remove('flickity-viewport-collection-tab');
              flickityViewport.classList.remove('flickity-viewport-collection-gemstones-astrology-tab');
              flickityViewport.classList.remove('flickity-viewport-collection-bridal-tab');
              if (button.dataset.collection === 'online-exclusive-collections') {
                flickityViewport.classList.add('flickity-viewport-collection-tab'); 
              }
              if (button.dataset.collection === 'pcc-lites') {
                flickityViewport.classList.add('flickity-viewport-collection-tab'); 
              }
              if (button.dataset.collection === 'wedding-collection') {
                flickityViewport.classList.add('flickity-viewport-collection-bridal-tab'); 
              }
              if (button.dataset.collection === 'mugdhaa-collection') {
                flickityViewport.classList.add('flickity-viewport-collection-tab'); 
              }
              if (button.dataset.collection === 'eterknight-collection') {
                flickityViewport.classList.add('flickity-viewport-collection-tab'); 
              }
              if (button.dataset.collection === 'little-jewels') {
                flickityViewport.classList.add('flickity-viewport-collection-tab'); 
              }
              if (button.dataset.collection === 'gemstones-astrology') {
                flickityViewport.classList.add('flickity-viewport-collection-gemstones-astrology-tab'); 
              }
            }
            if (handle) {
              this.toggleCollection(handle);
            }

            event.preventDefault();
          });
        });
      }, 10);
      if (Shopify.designMode) {
        this.addEventListener('shopify:block:select', (event) => {
          let index = this.buttons.indexOf(event.target);

          this.buttons[index].dispatchEvent(new Event('click'));
        });
      }
    }
    toggleCollection(handle) {
      let slider = document.getElementById(this.target),
        products = slider.querySelectorAll(`.columns:not([data-collection="${handle}"])`),
        active_products = slider.querySelectorAll(`[data-collection="${handle}"]`),
        flkty = Flickity.data(slider);

      [].forEach.call(products, function(el) {
        el.classList.remove('carousel__slide');
        slider.append(el);
      });
      [].forEach.call(active_products, function(el) {
        el.classList.add('carousel__slide');
      });
      flkty.insert(active_products);
      flkty.reloadCells();
      flkty.select(0, 0, 1);
    }
  }
  customElements.define('collection-tabs', CollectionTabs);
}